import { Loading } from "components/shared";
import React, { useEffect } from "react";
import usePostValidator from "utils/hooks/usePostValidator";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";

export const socialNetworkPrompts = {
    "instagram": "copy",
    "facebook": "copy",
    "twitter": "copy",
    "linkedin": "copy",
    "tiktok": "copy",
    "discord": "copy",
    "medium": "blog post",
    "pinterest": "copy",
    "youtube": "copy",
    "telegram": "copy",
}

// Instruction-only suffixes (no completion-style "Text:" / "Blog post:" cues —
// the result comes back structured via RESULT_SCHEMA).
export const socialNetworkPromptsSuffix = {
    "instagram": `INSTRUCTIONS:\n- Max 1200 characters\n- Min 150 characters`,
    "facebook": `INSTRUCTIONS:\n- Max 1200 characters\n- Min 150 characters`,
    "twitter": `INSTRUCTIONS:\n- Max 250 characters\n- Min 150 characters`,
    "linkedin": `INSTRUCTIONS:\n- Max 1200 characters\n- Min 250 characters`,
    "tiktok": `INSTRUCTIONS:\n- Max 250 characters\n- Min 25 characters`,
    "discord": ``,
    "medium": `Write the result in HTML using ONLY the following tags if needed: h1, h2, p, blockquote, b, strong, i, em, a, hr, br. Do not use the <style> tag.`,
    "pinterest": `INSTRUCTIONS:\n- Max 500 characters\n- Min 250 characters`,
    "youtube": ``,
    "telegram": ``,
}

const AdaptToSocialNetwork = ({ network, textToAdapt, setValue, setMenuOpened }) => {

    const { validationConstants } = usePostValidator();
    const { run, writeBackAll, closeMenu } = useMagicAction({ setValue, setMenuOpened });

    useEffect(() => {
        if (validationConstants?.[`${network}_feed`]?.description?.max_length) {
            run({
                prompt: `Adapt the following text into a ${socialNetworkPrompts[network]} for ${network}.\n${socialNetworkPromptsSuffix[network]}\n\nTEXT:\n${textToAdapt}`,
                schema: RESULT_SCHEMA,
            })
                .then((r) => writeBackAll(asText(r)))
                .finally(closeMenu);
        }
    }, [validationConstants]);

    return (
        <div className="flex items-center justify-center p-4 gap-2">
            <Loading type={'element'} />
        </div>
    )
}

export default AdaptToSocialNetwork;
